export default __webpack_public_path__ + "static/media/fw-sophia-er-Yellow Gold.ae7c9b02.mp4";